import React, { useEffect, forwardRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setCurrentLanguage } from '../../redux/actions/translations';
import classnames from 'classnames';

import './languageswitcher.scss';
import { ChevronUpIcon, CheckmarkIcon } from '../Icons/Icons';
import TextTranslate from '../TextTranslate/TextTranslate';

const LanguageSwitcher = ({ user, currentLanguage, languages, className = "", ...props }) => {

    useEffect(() => {
        if (user?.language) {
            changeSiteLanguage(user?.language?.code);
        }
    }, [user])

    const changeSiteLanguage = (langCode) => {
        const lang = languages.filter(language => language.code === langCode)[0]
        props.dispatch(setCurrentLanguage(lang));
    }

    const LanguageToggle = forwardRef(({ children, className, onClick }, ref) => (
        <div
            className={className}
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
        >
            {children}
        </div>
    ));

    const LanguageDropdownMenu = forwardRef(
        ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
            return (
                <div
                    ref={ref}
                    style={style}
                    className={className}
                    aria-labelledby={labeledBy}
                >
                    <ul className="list-unstyled">
                        {children}
                    </ul>
                </div>
            );
        },
    );

    return (
        <Dropdown className={classnames(['language-dropdown', className])} onSelect={(eventKey) => { changeSiteLanguage(eventKey) }}>
            <Dropdown.Toggle as={LanguageToggle} className="language-toggle">
                <p>
                    {currentLanguage.code ?
                        <TextTranslate name={`code-${currentLanguage.code.toLowerCase()}`} fallback={currentLanguage.name} textOnly /> :
                        'Default'
                    }
                </p>
                <ChevronUpIcon className="dropdown-icon" />
            </Dropdown.Toggle>

            <Dropdown.Menu as={LanguageDropdownMenu}>
                {
                    languages.map(lang => {
                        return (
                            <Dropdown.Item key={lang.code} eventKey={lang.code} active={currentLanguage.code === lang.code}>
                                {lang.name}
                                {currentLanguage.code === lang.code ? <CheckmarkIcon className="ml-1" /> : null}
                            </Dropdown.Item>
                        )
                    })
                }
            </Dropdown.Menu>
        </Dropdown>
    )
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
    languages: state.translations.languages,
    user: state.auth.user
});

export default connect(mapStateToProps)(LanguageSwitcher);